const listingTime = (property) => {
  const value = Date.parse(property.listing_contract_date);
  return Number.isFinite(value) ? value : 0;
};

// Merge county results before choosing the gallery, so county request order
// cannot crowd out newer homes from elsewhere in the service area.
export const selectFeaturedProperties = (properties, limit = 12) => {
  const seen = new Set();
  return [...properties]
    .sort((a, b) => listingTime(b) - listingTime(a))
    .filter((property) => {
      const key = property.listing_key || property.listingKey;
      if (!key || seen.has(String(key)) || !(Number(property.current_price) >= 1000000)) return false;
      seen.add(String(key));
      return true;
    })
    .slice(0, limit)
    .map((property) => ({ ...property, featured_source: 'market' }));
};
